import { Injectable } from '@angular/core';
import { ReceiptModeApiService } from '@cms/apis';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { catchError, EMPTY, exhaustMap, map } from 'rxjs';
import { ReceiptModeAction } from '../actions';
import { FnWithCompany, WithCompany } from '@cms/backgrounds/switch-company';

@Injectable()
export class ReceiptModeEffect {
  loadItem$ = createEffect(() =>
    this._actions$.pipe(
      ofType(ReceiptModeAction.loadItem),
      exhaustMap(action =>
        this.fetch(action.id).pipe(
          map(item => ReceiptModeAction.loadItemSuccess({ item })),
          catchError(() => EMPTY)
        )
      )
    )
  );

  @FnWithCompany()
  fetch(id: number, @WithCompany() option: Record<string, any> = {}) {
    return this._apiService.get(id, option);
  }


  constructor(
    private _apiService: ReceiptModeApiService,
    private _actions$: Actions,
    private _store: Store
  ) { }
}
